import React from 'react';
import { clsx, multiply, createUseStyles } from '@pushpay/styles';
import { getColors, shimmerAnimation, getShimmerStyles } from './shared';
const useStyles = createUseStyles(theme => {
  const {
    baseColor,
    shimmerColor,
    lighterShimmerColor
  } = getColors(theme);
  const chartGutter = '3em';
  const barPadding = '2px';
  const barStyles = { ...getShimmerStyles(theme, {
      opacity: 0,
      backgroundColor: lighterShimmerColor,
      animation: '$shimmer 2s infinite'
    }),
    width: `calc(50% - ${barPadding})`,
    borderRadius: `${theme.SHAPE.ROUNDED_CORNERS} ${theme.SHAPE.ROUNDED_CORNERS} 0 0`
  };
  const axisLabelStyles = {
    content: '""',
    position: 'absolute',
    left: 0,
    width: '2.5em',
    height: '1em',
    borderRadius: '1em',
    transform: `translate(-${chartGutter}, -50%)`
  };
  return {
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      padding: `0 ${chartGutter} 0 ${multiply(chartGutter, 2)}`,
      zIndex: 0
    },
    barGroup: {
      display: 'flex',
      listStyle: 'none',
      alignItems: 'flex-end',
      margin: 0,
      padding: 0
    },
    first: { ...barStyles,
      backgroundColor: baseColor
    },
    second: { ...barStyles,
      backgroundColor: shimmerColor,
      marginLeft: multiply(barPadding, 2)
    },
    background: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: -1
    },
    axis: {
      position: 'relative',
      height: '1px',
      backgroundColor: theme.colors['palette-grey-light-200'],
      width: `calc(100% - ${chartGutter})`,
      '&:before': { ...axisLabelStyles,
        backgroundColor: baseColor
      },
      '&:after': { ...axisLabelStyles,
        opacity: 0,
        backgroundColor: lighterShimmerColor,
        animation: '$shimmer 2s infinite'
      }
    },
    ...shimmerAnimation
  };
});
const baseGroups = [[20, 30], [45, 60], [70, 65], [95, 80], [70, 60], [45, 30]];
export const SkeletonBarChart = props => {
  const {
    groups,
    classes: classesProp,
    className: classNameProp,
    padding = 0.5,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const barGroups = Array(groups).fill(null).map((_, index) => baseGroups[index % baseGroups.length]); // The bars take one third of the space.

  const barGroupWidth = `${100 / barGroups.length * (1 - Math.max(Math.min(padding, 0.9), 0))}%`;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), barGroups.map(([first, second], index) => {
    const key = `bar-${index}`;
    return /*#__PURE__*/React.createElement("ul", {
      key: key,
      className: classes.barGroup,
      style: {
        width: barGroupWidth
      }
    }, /*#__PURE__*/React.createElement("li", {
      className: classes.first,
      style: {
        height: `${first}%`
      }
    }), /*#__PURE__*/React.createElement("li", {
      className: classes.second,
      style: {
        height: `${second}%`
      }
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.background
  }, Array(5).fill(null).map((_, index) => {
    const key = `axis-${index}`;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classes.axis
    });
  })));
};